import { render } from "./icon-bootstrap.vue?vue&type=template&id=56cade59"
import script from "./icon-bootstrap.vue?vue&type=script&lang=js"
export * from "./icon-bootstrap.vue?vue&type=script&lang=js"

import "./icon-bootstrap.vue?vue&type=style&index=0&id=56cade59&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__